import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Banner, HelpIcon } from '@thermon-platforms/thermon-ui-core';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { debounce } from 'lodash';
import api, { parseErrors } from 'util/api';


function ChangePasswordModal({user, close}) {
  const [processing, setProcessing] = useState(false);
  const [newPassword, setNewPassword] = useState({});
  const [errors, setErrors] = useState();
  const [success, setSuccess] = useState(false);

  function finish() {
    setProcessing(true);
    // Handle any errors
    if (newPassword.newPassword != newPassword.confirmPassword) {
      setProcessing(false);
      setErrors({
        confirmPassword: t`Passwords do not match`
      });
      return;
    }
    // Fake request delay
    // await new Promise(resolve => setTimeout(resolve, 500));
    api(`/users/${user.id}/password`, {
      method: 'PUT',
      // NOTE - empty currentPassword is a nasty hack to use a single endpoint
      body: JSON.stringify(Object.assign({id: user.id, currentPassword: ''}, newPassword))
    })
    .then(() => {
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
      }, 10 * 1000);
    })
    .catch(async res => {
      const newErrors = parseErrors(await res.json());
      if (newErrors.PasswordRequiresNonAlphanumeric) {
        setErrors({
          newPassword: newErrors.PasswordRequiresNonAlphanumeric
        });
        return;
      }
      if (newErrors.PasswordRequiresUpper) {
        setErrors({
          newPassword: newErrors.PasswordRequiresUpper
        });
        return;
      }
      if (newErrors.PasswordMismatch) {
        setErrors({
          currentPassword: newErrors.PasswordMismatch
        });
        return;
      }
    })
    .finally(() => {
      setProcessing(false);
    });
  }

  const handlePasswordChange = debounce((value, key) => {
    // When the input changes, clear errors
    // NOTE - we may want to make this more targeted
    setErrors(undefined);
    // Create a new object so setting state works
    const passwordObj = Object.assign({}, newPassword);
    passwordObj[key] = value;
    // Set the new state
    setNewPassword(passwordObj);
  }, 200);

  return (
    <I18nProvider i18n={i18n}>
      <header>
        <h3>
          <Trans>Change Password for</Trans> {user.fullName}
        </h3>
      </header>
      <section>
        <Banner show={errors} status="alert" small={true}>
          <Trans>There was an error updating the password</Trans>
        </Banner>
        <Banner show={success} status="ok" small={true}>
          <Trans>Password updated successfully</Trans>
        </Banner>
        <ul className="form">
          <li>
            <label htmlFor="newPassword"><Trans>New Password</Trans></label>
            <input
              type="password"
              id="newPassword"
              name="newPassword"
              autoComplete="new-password"
              defaultValue={newPassword.newPassword}
              className={errors?.newPassword ? 'error' : ''}
              onChange={event => handlePasswordChange(event.target.value, 'newPassword')}
            />
            {errors?.newPassword ?
              <p className="error-text">{errors?.newPassword}</p>
            : <></>}
          </li>
          <li>
            <label htmlFor="confirmPassword"><Trans>Confirm New Password</Trans></label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              className={errors?.confirmPassword ? 'error' : ''}
              autoComplete="new-password"
              defaultValue={newPassword.confirmPassword}
              onChange={event => handlePasswordChange(event.target.value, 'confirmPassword')}
            />
            {errors?.confirmPassword ?
              <p className="error-text">{errors?.confirmPassword}</p>
            : <></>}
          </li>
          <li>
            <label htmlFor="currentPassword">
              <Trans>Enter Your Password</Trans>
              <HelpIcon text={t`To verify your identity, please enter your current password.`} />
            </label>
            <input
              type="password"
              id="currentPassword"
              name="currentPassword"
              autoComplete="current-password"
              defaultValue={newPassword.currentPassword}
              className={errors?.currentPassword ? 'error' : ''}
              onChange={event => handlePasswordChange(event.target.value, 'currentPassword')}
            />
            {errors?.currentPassword ?
              <p className="error-text">{errors?.currentPassword}</p>
            : <></>}
          </li>
        </ul>
      </section>
      <footer>
        <button onClick={close}>
          <Trans>Close</Trans>
        </button>
        <button
          className={`primary ${processing ? 'processing' : ''}`}
          onClick={finish}
          disabled={processing}
        >
          <Trans>Save</Trans>
        </button>
      </footer>
    </I18nProvider>
  );
}

export default ChangePasswordModal;
